type GTagEvent = {
  action: string;
  params: Record<string, string | number | boolean>;
};

const LOCALE_PREFIX_REGEX = /^\/(sv|en)(\/|$)/;

function stripLocale(path: string): string {
  return path.replace(LOCALE_PREFIX_REGEX, '/');
}

function getLocale(): string {
  if (typeof window === 'undefined') return '';
  const match = window.location.pathname.match(LOCALE_PREFIX_REGEX);
  return match?.[1] ?? 'sv';
}

function getPagePath(): string {
  if (typeof window === 'undefined') return '';
  return stripLocale(window.location.pathname);
}

function sendEvent({ action, params }: GTagEvent) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', action, {
    page_path: getPagePath(),
    locale: getLocale(),
    ...params,
  });
}

// ── CTA / Button clicks ──────────────────────────────────────────────

export function trackCtaClick({buttonText, targetUrl, buttonType, contentId}: {buttonText: string, targetUrl: string, buttonType: string, contentId: string}) {
  sendEvent({
    action: 'cta_click',
    params: {
      button_text: buttonText,
      button_target_url: stripLocale(targetUrl),
      button_type: buttonType,
      content_id: contentId,
    },
  });
}

// ── Form events ──────────────────────────────────────────────────────

export function trackFormSubmit({formName, contentId}: {formName: string, contentId: string}) {
  sendEvent({
    action: 'form_submit',
    params: {
      form_name: formName,
      content_id: contentId,
    },
  });
}

export function trackFormError({formName, errorType, contentId}: {formName: string, errorType: string, contentId: string}) {
  sendEvent({
    action: 'form_error',
    params: {
      form_name: formName,
      error_type: errorType,
      content_id: contentId,
    },
  });
}

// ── Social sharing ───────────────────────────────────────────────────

export function trackShare({platform}: {platform: string}) {
  sendEvent({
    action: 'share',
    params: {
      method: platform,
    },
  });
}
